import {convertRowsToData} from '../utils/dataUtils'

export default function HeatMapDataController (rows) {
  
  let propperHeaders = ['id','x','y','color']
  let headers = rows[0]
  
  if(headers.length<propperHeaders.length) rows = rows.map((r,i)=>[i,...r])
  
  let data = convertRowsToData([propperHeaders,...rows.slice(1)],3)  

  return data.map((point)=>{
    return {
      id: point.id, //point.value.find((d)=>d.id==='x').value+'_'+point.value.find((d)=>d.id==='y').value
      x: point.value.find((d)=>d.id==='x').value,
      y: point.value.find((d)=>d.id==='y').value,
      color: point.value.find((d)=>d.id==='color').value
    }
  })
}